/* 数字区间组件 */
import React from 'react';
import { InputItemBlock } from '@beisen/chaos-ui';
import transLoader from '@beisen/i18n-translation-loader';
import { fixPrecision, formatSymbol } from '../../util/digitHelper';

const defaultTranslation = {
    searchInputHolder: '点击输入',
    confirm: '确定',
    clear: '清空'
};
class DigitalInterval extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlurLeft = this.handleBlurLeft.bind(this);
        this.handleBlurRight = this.handleBlurRight.bind(this);
        this.handleClearValue = this.handleClearValue.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        let valueArr = (this.props.searchParams
            ? this.props.searchParams.text.replace(/(-*\d+)(-)/, '$1~')
            : ''
        ).split('~');
        this.state = {
            leftV:
                isNaN(valueArr[0]) && valueArr[0] !== undefined
                    ? valueArr[0]
                    : this.formatValue(valueArr[0] || ''),
            rightV:
                isNaN(valueArr[1]) && valueArr[1] !== undefined
                    ? valueArr[1]
                    : this.formatValue(valueArr[1] || '')
        };
        this.translation = Object.assign(
            {},
            defaultTranslation,
            transLoader({
                clear: 'common.clear',
                confirm: 'common.confirm',
                searchInputHolder: 'fieldPlaceHolder.searchInputHolder'
            }),
            props.translation
        );
    }

    componentWillReceiveProps(nextProps) {
        //if(this.props.text != nextProps.text || this.props.value != nextProps.value) {
        let value = nextProps.searchParams ? nextProps.searchParams.text : '';
        let valueArr = value.match('~') ? value.split('~') : value.split('-');
        this.setState({
            leftV:
                isNaN(valueArr[0]) && valueArr[0] !== undefined
                    ? valueArr[0]
                    : this.formatValue(valueArr[0]),
            rightV:
                isNaN(valueArr[1]) && valueArr[1] !== undefined
                    ? valueArr[1]
                    : this.formatValue(valueArr[1] || '')
        });
        //}
    }

    handleChange(value) {}

    formatValue(value) {
        if (typeof value == 'undefined') {
            return '';
        }
        if (value === '' || isNaN(value)) {
            return value;
        }
        value = value
            .trim()
            .replace(/,/g, '')
            .replace('%', '');
        const {
            precision,
            formatType,
            containsTrailingZero
        } = this.props.cmp_data;
        const fixedPrecisionText = fixPrecision(
            value,
            precision,
            containsTrailingZero
        );
        const textValue = formatSymbol(fixedPrecisionText, formatType);
        return textValue || '';
    }

    handleBlurLeft(value) {
        let leftV = '';
        if (value !== '') {
            leftV = this.formatValue(value);
        }
        let valueObj = {
            text: leftV + '~' + this.state.rightV,
            value:
                (isNaN(Number(leftV))
                    ? leftV.replace(/,/g, '').replace(/\%/, '')
                    : leftV) +
                '^' +
                (isNaN(Number(this.state.rightV))
                    ? this.state.rightV.replace(/,/g, '').replace(/\%/, '')
                    : this.state.rightV)
        };
        if (value == '' && this.state.rightV == '') {
            valueObj = { text: '', value: '' };
        }
        this.handleBlur(valueObj);
    }

    handleBlurRight(value) {
        let rightV = '';

        if (value !== '') {
            rightV = this.formatValue(value);
        }
        let valueObj = {
            text: this.state.leftV + '~' + rightV,
            value:
                (isNaN(Number(this.state.leftV))
                    ? this.state.leftV.replace(/,/g, '').replace(/\%/, '')
                    : this.state.leftV) +
                '^' +
                (isNaN(Number(rightV))
                    ? rightV.replace(/,/g, '').replace(/\%/, '')
                    : rightV)
        };
        if (value == '' && this.state.leftV == '') {
            valueObj = { text: '', value: '' };
        }
        this.handleBlur(valueObj);
    }

    handleBlur(value) {
        this.props.onBlur && this.props.onBlur(value);
    }

    handleSubmit() {
        // this.props.handleClosePopUp && this.props.handleClosePopUp();
        this.props.synBizData && this.props.synBizData();
    }

    handleClearValue() {
        this.props.onBlur && this.props.onBlur({ text: '', value: '' });
        this.props.handleClosePopUp && this.props.handleClosePopUp();
        this.props.synBizData && this.props.synBizData();
    }

    render() {
        const symbol =
            this.props.cmp_data.formatType == 'percentageSymbol' ||
            this.props.cmp_data.formatType == 'thousandPercentageSymbol'
                ? '(%)'
                : '';
        return (
            <InputItemBlock
                label={this.props.label + symbol}
                leftV={this.state.leftV}
                rightV={this.state.rightV}
                onChange={this.handleChange}
                onBlurLeft={this.handleBlurLeft}
                onBlurRight={this.handleBlurRight}
                popType={this.props.pop_type}
                onSubmit={this.handleSubmit}
                onClearValue={this.handleClearValue}
                translation={this.translation}
            />
        );
    }
}

export default DigitalInterval;



// WEBPACK FOOTER //
// ./src/components/Field_Components/DigitalInterval/DigitalInterval.js